const iframe = document.querySelector('.quickcheck iframe');

window.addEventListener('message', function(event) {
    if (event.data.iframeHeight && iframe) {
        const newHeight = event.data.iframeHeight + 'px';
        if (iframe.style.height !== newHeight) {
            iframe.style.height = newHeight;
        }
    }
});